import { useState } from "react";
import { Gift, Check } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export const ReferralNudge = ({ className = "" }) => {
  const [copied, setCopied] = useState(false);

  const invite = async () => {
    try {
      const { data } = await api.get("/referral");
      const link = `${window.location.origin}/auth?ref=${data.code}`;
      const text = `Mia keeps me on top of school without the nagging — try StudySpark free for 7 days: ${link}`;
      if (navigator.share) {
        await navigator.share({ title: "StudySpark", text, url: link });
      } else {
        await navigator.clipboard.writeText(link);
        toast.success("Invite link copied — send it to a friend!");
      }
      setCopied(true);
    } catch (e) {
      if (e?.name !== "AbortError") toast.error("Couldn't grab your invite link.");
    }
  };

  return (
    <button
      onClick={invite}
      data-testid="referral-nudge-button"
      className={`w-full flex items-center justify-center gap-2 text-sm font-bold bg-white border-2 border-black rounded-full shadow-[3px_3px_0px_rgba(0,0,0,1)] active:shadow-none active:translate-y-[2px] transition-all px-4 py-2.5 ${className}`}
    >
      {copied ? <Check size={16} className="text-[#51CF66]" /> : <Gift size={16} />}
      Gift a friend a free trial — you earn a free month
    </button>
  );
};
